// import { message } from "antd";
// import { ErrorIcon } from "../../CustomIcons";

// const ErrorMessage = (text: string) => {
//   const myMessage = () => {
//     message.error({
//       key: "error",
//       type: "error",
//       content: (
//         <div className="toast_wrapper">
//           <div className="toast_text">{text}</div>
//         </div>
//       ),
//       icon: <ErrorIcon />,
//     });
//   };

//   return myMessage();
// };

// export default ErrorMessage;

import { message } from "antd";
import { ErrorIcon } from "../../CustomIcons";

export const ErrorMessage = (text: string) => {
  message.error({
    key: "error",
    duration: 2,
    content: (
      <div className="toast_wrapper">
        <div className="toast_text">{text}</div>
      </div>
    ),
    icon: <ErrorIcon />,
  });
};
